import { TokenListItem } from "@eulerxyz/core-sdk"

// Stubbed fallback token list - tokens are fetched from API in production
export function getFallbackTokenList(_chainId: number, _extra = false): TokenListItem[] {
  return []
}
